import { useState, useEffect } from "react";
import { ShowsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "i18n-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useShows(status, licenseeID, recognized) {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const { t } = useTranslation("common");

  useEffect(() => {
    const fetchShows = async () => {
      if (!auth.user?.access_token) {
        setError(t("shows.list.authError"));
        setLoading(false);
        return;
      }

      try {
        const api = new ShowsApi(
          new Configuration({
            basePath: MANAGER_API_BASE_URL,
            accessToken: auth.user.access_token,
          })
        );
        const { data } = await api.listShows(status, licenseeID, recognized);
        setShows(data || []);
        setError(null);
      } catch (err) {
        console.error("Error fetching shows:", err);
        setError(t("shows.list.error"));
      } finally {
        setLoading(false);
      }
    };

    fetchShows();
  }, [auth.user, status, licenseeID, recognized, t]);

  return { shows, loading, error };
}
